exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"CookiesPage.scss?vue&type=style&index=0&id=3261820e&lang=scss&scoped=true&","sourceRoot":""}]);

// exports
